import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { setBreadcrumb } from '../actions/breadcrumb'

import { RETURNS } from '../assets/constant'
import { isEmpty } from '../assets/utils'

import Item from './Item';

class SummaryItems extends React.Component {

  constructor(props) {
    super()
    this.props = props
    this.onClick = this.onClick.bind(this)
    this.itemReturned = this.itemReturned.bind(this)
  }

  customerName() {
    if (this.props.customer) {
      return this.props.customer.first_name + ' ' + this.props.customer.last_name
    }
  }

  customerAddress(){
    if (this.props.customer) {
      return this.props.customer.address.line1 + ', ' + this.props.customer.address.zipcode + ' ' + this.props.customer.address.city
    }
  }

  onClick() {
    if (!this.props.shipback.charged) {
      this.props.setBreadcrumb(RETURNS)
    }
  }

  itemReturned() {
    for (var i = 0; i < this.props.items.length; i++) {
      var item = this.props.items[i]
        if (item.returned) {
          return true
        }
      }
    return false
  }

  render() {
    if (!isEmpty(this.props.shipback) && this.itemReturned()) {
      return (
        <div className="items">
          <a href="#" onClick={this.onClick}>
            <h3>{ I18n.t('layouts.summary.items.title') }</h3>
            {this.props.items.map((item) => (
              <Item key={item.id} item={item}/>
            ))}
          </a>
          <hr className="separator" />
        </div>
      )
    } else {
      return (<div></div>)
    }
  }
}

const mapStateToProps = state => ({
  items: state.items.list,
  shipback: state.shipback
})

const mapDispatchToProps = dispatch => bindActionCreators({ setBreadcrumb }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(SummaryItems)


// WEBPACK FOOTER //
// ./app/javascript/components/components/SummaryItems.jsx